import { render, staticRenderFns } from "./withdrawResult.vue?vue&type=template&id=99743366&scoped=true&"
import script from "./withdrawResult.vue?vue&type=script&lang=js&"
export * from "./withdrawResult.vue?vue&type=script&lang=js&"
import style0 from "./withdrawResult.vue?vue&type=style&index=0&id=99743366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99743366",
  null
  
)

export default component.exports